import { BrandsContainer } from '@/modules/Brands';

export const Brands = (): JSX.Element => <BrandsContainer />;

export default Brands;
